import { SelectedProductDTO } from "@models/platform-analysis/entities/steps/feature";
import { ProductRecommendationDTO } from "@models/platform-analysis/entities/steps/summary";
import { useTheme } from "@mui/material";
import { getProductRecommendationConfigs } from "@pages/platform-analysis-v2/_id/steps/summary/utils";
import { Text, View } from "@react-pdf/renderer";
import { toSentence } from "@utils";
import { PDFStyleConfigs } from "../../../configs";

export const RecommendationLabel = ({
  product,
  productRecommendations,
  initialProductRecommendation,
  shouldIncreaseHeight = false,
}: {
  product?: SelectedProductDTO;
  productRecommendations?: Record<string, Partial<ProductRecommendationDTO>>;
  shouldIncreaseHeight?: boolean;
  initialProductRecommendation?: Partial<ProductRecommendationDTO>;
}) => {
  const { palette } = useTheme();

  const { backgroundColor, label, isCustomType } = initialProductRecommendation
    ? getProductRecommendationConfigs(initialProductRecommendation)
    : getProductRecommendationConfigs(
        productRecommendations?.[product?.id ?? ""],
      );

  return backgroundColor ? (
    <View
      style={{
        height: shouldIncreaseHeight
          ? PDFStyleConfigs.TableRowRecommendationDoubleHeight
          : PDFStyleConfigs.TableRowRecommendationHeight,
        width: "100%",
        backgroundColor: backgroundColor || "transparent",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          fontSize: 7,
          paddingTop: 1,
          color: palette.common.white,
          textAlign: "center",
        }}
      >
        {isCustomType ? label : toSentence(label)}
      </Text>
    </View>
  ) : (
    <></>
  );
};
